import { type PollDto } from '../api/polls'

export type Poll = {
  /** ID of the Poll */
  id: number
  /** The poll question */
  question: string
  /** Is the poll open */
  started: boolean
  /** Date of when the poll was opened */
  startedAt: string
  /** Options related to the question of the poll */
  options: Array<{
    /** ID of the poll option */
    id: number
    /** The poll option */
    option: string
    /** Numbers of answers related to the poll option */
    count: number
  }>
}

/** Mapper object for mapping between a poll and its network counterpart */
export const pollMapper = () => ({
  /**
   * Map from a data transfer object into a `Poll`
   *
   * @param {PollDto} dto A poll data transfer object served over the network
   * @returns {Poll} An enriched `Poll` object
   */
  fromDto(dto: PollDto): Poll {
    return {
      id: dto.poll_id,
      question: dto.question,
      started: dto.open_p,
      startedAt: dto.opened_date,
      options: dto.options.map((option) => ({
        id: option.poll_option_id,
        option: option.option,
        count: option.answer_count,
      })),
    }
  },
})
